@let isLoading = isLoading$ | async;

<mat-form-field appearance="outline" class="w-full no-padding">
  <mat-label>{{label}}</mat-label>
  <input
    type="text"
    matInput
    [formControl]="ctrl"
    [matAutocomplete]="auto"
    #autoTrigger="matAutocompleteTrigger"
    [placeholder]="placeholder || label"
    (input)="onSearchChanged()"
    (blur)="onBlur()"
  >
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" (optionSelected)="onOptionSelected($event.option.value)">
    @if (!isLoading && !options?.length) {
      <mat-option [disabled]="true">
        {{ emptyOptionLabel }}
      </mat-option>
    }
    <mat-option *ngFor="let option of options" [value]="this.valueKey ? option?.[this.valueKey] : option">
      {{ option?.[this.labelKey] }}
    </mat-option>
  </mat-autocomplete>

  <div matSuffix class="flex items-center">
    @if (showClear && ctrl?.value) {
      <button tabindex="-1" type="button" matIconButton class="me-1 clear-button mat-primary" (mousedown)="$event.preventDefault()" (click)="clearAll()">
        <fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
      </button>
    }

    @if (isLoading) {
      <mat-spinner class="mx-2" [diameter]="18" [strokeWidth]="2"></mat-spinner>
    }

    <fa-icon
      class="si-icon si-select-arrow"
      [class.si-select-arrow--open]="autoTrigger.panelOpen"
      [icon]="['fal', 'chevron-down']"
    ></fa-icon>
  </div>

</mat-form-field>
